var lib_core = require("lib-core");
var model3d = require("./model3d.js");

var Model3DReference = function (assetType, assetId) {
    this.makeObservableTreeNode();
    this.initModelHandlers();
    
    var self = this;
    // store the id and the file type of the origional asset.
    this.defaultTypes = ["step", "stp"]; // const

    this.assetType = this.value("assetType", true);
    this.assetId = this.value("assetId", true);
    // this.assetVersion = this.value("assetVersion", true);
    
    // these things can be checked after calculateGeometryInfo is called
    this.emptyFromXref = false;
    this.emptyFromNoGeom = false;
    this.isFusionLinked = false;

    if(assetType != undefined) this.assetType(assetType);
    if(assetId != undefined) this.assetId(assetId);
};

lib_core.mixin(Model3DReference, lib_core.ObservableTreeNode);
lib_core.mixin(Model3DReference, model3d);

module.exports = Model3DReference;

lib_core.JsonParser.registerClass(Model3DReference, "Model3DReference");


Model3DReference.prototype.calculateGeometryInfo = function(showError){
    var self = this;
    // this line needs to come first
    if(this.hasModelCache()){
         return new Promise(function(resolve){ resolve(  self.getModelCache() )});
    }
    
    if(self.emptyFromXref) return Promise.resolve(self.buildFusionPlaceholder());
    if(self.emptyFromNoGeom) return Promise.resolve(self.buildFusionPlaceholder());

    // first we need to figure out if this is a situation where the OBJ is expected to be missing.
    return new Promise(function(resolve, reject){
      return self.getResource().then(res=>{
        if(res.forked_from && res.forked_from.wip_urn){
          self.isFusionLinked = true;
        }
        
        // turned off xref handling
        // if(res.hasXrefs){
        //   // we know obj will not work, put in empty geometry.
        //   self.emptyFromXref = true;
        //   resolve(self.buildFusionPlaceholder())
        // } else 
        if(res.f3d && res.stepStatus=="complete" && res.objStatus == "failed"){
          // the case where the f3d and step are fine but obj failed-
          // right now it means it must be empty
          self.emptyFromNoGeom = true;
          if(self.isFusionLinked){
            resolve(self.buildFusionPlaceholder())
          } else {
            resolve(self.buildEmptyPlaceholder())
          }
          
        } else {
          // no special case, throw error if obj is missing
          // get obj file
          let ignoreErrors = true;
          if(showError) ignoreErrors = false;
          return self.getFileData('obj', ignoreErrors)
          .then( function(objFile){ 
              // get mtl file
              return self.getFileData('mtl', true)
              .then( function(mtlFile){
                   resolve( self.buildFromFiles(objFile, mtlFile) )
              })
              .catch( function(error) {
                   resolve( self.buildFromFiles(objFile, null) );
              })
          })
          .catch( function(error) {
              return self.getResource().then(errorRes=>{
                // if origin was f3d and step succeeded, we can still use this model, we just can't render it in the web
                if(errorRes.f3d && errorRes.stepStatus=="complete"){
                  self.emptyFromNoGeom = true;
                  if(self.isFusionLinked){
                    resolve(self.buildFusionPlaceholder())
                  } else {
                    resolve(self.buildEmptyPlaceholder())
                  }
                } else {
                   reject("necessary translations did not finish."); 
                }
              })
              
          })
        }
      })
    })

     
}


Model3DReference.prototype.toString = function() {
    return `Model3DReference(${this.assetId()}, ${this.assetType()})`;
};


// async
Model3DReference.prototype.convertTo = function(fileType) {
    return this.root.dataLoader.convertModel(fileType, this.assetId());
}

// async
Model3DReference.prototype.getConversionStatus = function(fileType) {
    return this.root.dataLoader.getModelStatus(fileType, this.assetId());
};

// async
Model3DReference.prototype.getFileData = function(fileType, ignoreErrors) {
    var self = this;
    
    /////
    
    let getError = function(){
      return new Error("This file has not finished translating.  It could still be working, or it could be corrupt.")
    }
    
    let checkStatus = function(info){	
      if(info.status == "translating"){	
          if(info.progress == "complete"){	
              return true;	
          }	
      } else if(info.status == "complete" || info.status == "failed" || info.status == "missing"){
          //still true instead of false to let the getModel call throw the error.
          return true;	
      }	
      return false;	
    }
    
    let _pollUntilDone = (type, resolve, reject) => {
      return this.getConversionStatus(type)
      .then(function(info){
        if(checkStatus(info)){
          resolve();
        }
        else {
            setTimeout(() => {
                return _pollUntilDone(type, resolve, reject)
            }, 1000);
        }
      })
    }

    let pollUntilDone = (type) => {
        return new Promise((resolve, reject) => {
            return _pollUntilDone(type, resolve, reject);
        })
    }
    
    // if one of the step types...
    if(this.defaultTypes.indexOf(fileType.toLowerCase()) != -1){

      return pollUntilDone('f3d')
          .then(() => {
              return pollUntilDone('model')
          })
          .then(function(info){
              return self.root.dataLoader.getModel('model', self.assetId(), ignoreErrors);
          })

    } else if(fileType == 'f3d'){

      return pollUntilDone('f3d')
        .then(function(info){
          return self.root.dataLoader.getModel('f3d', self.assetId(), ignoreErrors);
        })

    } else {

        var statusType = (fileType == "mtl")? "obj": fileType;

        return pollUntilDone('f3d')
            .then(() => {
                return pollUntilDone(statusType)
            })
            .then(function(info){
                return self.root.dataLoader.getModel(fileType, self.assetId(), ignoreErrors);
            })
    }
};

Model3DReference.prototype.getResource = function() {
    return this.root.dataLoader.dataManager.getResource("3dmodel", this.assetId());
};
 






